// routes.js

import Campaigns from "../views/campaigns/Campaigns";
import EditCampaign from "../views/campaign/edit/EditCampaign";
import ShowCampaign from "../views/campaign/show/ShowCampaign";
import ShowDashboard from "../views/dashboard/show/ShowDashboard";
import TrackingList from "../views/trackingList/TrackingList";
import Error404 from "../views/Error404";
import BlaBlaBla from "../views/tests/bla/BlaBlaBla";
import TemplateModules from "../views/templates/modules/TemplateModules";
import TemplateSpaces from "../views/templates/spaces/TemplateSpaces";
import TemplateInteractions from "../views/templates/interactions/TemplateInteractions";
import CreateModuleTemplate from "../views/templates/modules/CreateModuleTemplate";
import EditModuleTemplate from "../views/templates/modules/EditModuleTemplate";
import CreateSpaceTemplate from "../views/templates/spaces/CreateSpaceTemplate";
import EditSpaceTemplate from "../views/templates/spaces/EditSpaceTemplate";
import TemplateTrackingLists from "../views/templates/trackingLists/TemplateTrackingLists";
import CreateTrackingListTemplate from "../views/templates/trackingLists/CreateTrackingListTemplate";
import EditTrackingListTemplate from "../views/templates/trackingLists/EditTrackingListTemplate";
import ShowReporting from "../views/dashboard/show/ShowReporting";
import Impressum from "../views/impressum/Impressum";

const routes = [
    {
        path: '/',
        name: 'campaigns',
        component: Campaigns,
        meta: {
            breadCrumb: 'Kampagnenübersicht',
            parents: [
                {route: '/campaigns', name: 'Kampagnen'}
            ]
        }
    }, {
        path: '/impressum',
        name: 'impressum',
        component: Impressum,
        meta: {
            breadCrumb: 'AD ALLIANCE',
            parents: [
                {route: '/impressum', name: 'impressum'}
            ]
        }
    },
    {
        path: '/bla',
        component: BlaBlaBla,
        meta: {
            breadCrumb: 'Bla bli blub',
            parents: [{route: '/campaigns', name: 'Kampagnen'}]
        }
    },
    {
        path: '/campaigns',
        redirect: {
            name: 'campaigns'
        }
    },
    {
        path: '/campaigns/create',
        name: 'createCampaign',
        component: EditCampaign,
        meta: {
            breadCrumb: 'Kampagne erstellen',
            parents: [{route: '/campaigns', name: 'Kampagnen'}]
        }
    },
    {
        path: '/campaigns/:id',
        name: 'showCampaign',
        component: ShowCampaign,
        meta: {
            breadCrumb: 'Kampagnenansicht',
            parents: [{route: '/campaigns', name: 'Kampagnen'},{route: '/campaigns/:id/edit', name: 'Kampagne bearbeiten'}]
        }
    },
    {
        path: '/campaigns/:id/edit',
        name: 'editCampaign',
        component: EditCampaign,
        meta: {
            breadCrumb: 'Kampagne bearbeiten',
            parents: [{route: '/campaigns', name: 'Kampagnen'}, {route: '/campaigns/:id', name: 'Kampagnenansicht'}]
        }
    },
    {
        path: '/campaigns/:id/dashboard',
        name: 'showDashboard',
        component: ShowDashboard,
        meta: {
            breadCrumb: 'Dashboard',
            parents: [{route: '/campaigns/:id', name: 'Kampagne'}]
        }
    },
    {
        path: '/campaigns/:id/reporting',
        name: 'showReporting',
        component: ShowReporting,
        meta: {
            breadCrumb: 'Reporting',
            parents: [{route: '/campaigns/:id', name: 'Kampagne'}]
        }
    },
    {
        path: '/campaigns/:id/trackinglist/:trackinglist_id',
        name: 'trackinglist',
        component: TrackingList,
        meta: {
            breadCrumb: 'Tracking-Liste',
            parents: [{route: '/campaigns', name: 'Kampagnen'}, {route: '/campaigns/:id', name: 'Kampagnenansicht'}]
        }
    },
    {
        path: '/templates/modules',
        name: 'templatemodules',
        component: TemplateModules,
        meta: {
            breadCrumb: 'Vorlagen',
            parents: []
        }
    },
    {
        path: '/templates/modules/create',
        name: 'createmoduletemplate',
        component: CreateModuleTemplate,
        meta: {
            breadCrumb: 'Modul erstellen',
            parents: [{route: '/templates/spaces', name: 'Vorlagen'}, {route: '/templates/modules', name: 'Module'}]
        }
    },
    {
        path: '/templates/modules/:id/update',
        name: 'editmoduletemplate',
        component: EditModuleTemplate,
        meta: {
            breadCrumb: 'Modul aktualisieren',
            parents: [{route: '/templates/spaces', name: 'Vorlagen'}, {route: '/templates/modules', name: 'Module'}]
        }
    },
    {
        path: '/templates/spaces',
        name: 'templatespaces',
        component: TemplateSpaces,
        meta: {
            breadCrumb: 'Vorlagen',
            parents: []
        }
    },
    {
        path: '/templates/spaces/create',
        name: 'createspacetemplate',
        component: CreateSpaceTemplate,
        meta: {
            breadCrumb: 'Space erstellen',
            parents: [{route: '/templates/spaces', name: 'Vorlagen'}]
        }
    },
    {
        path: '/templates/spaces/:id/update',
        name: 'editspacetemplate',
        component: EditSpaceTemplate,
        meta: {
            breadCrumb: 'Space aktualisieren',
            parents: [{route: '/templates/spaces', name: 'Vorlagen'}]
        }
    },
    {
        path: '/templates/interactions',
        name: 'templateinteractions',
        component: TemplateInteractions,
        meta: {
            breadCrumb: 'Vorlagen',
            parents: []
        }
    },
    {
        path: '/templates/trackinglists',
        name: 'templatetrackinglists',
        component: TemplateTrackingLists,
        meta: {
            breadCrumb: 'Vorlagen',
            parents: []
        }
    },
    {
        path: '/templates/trackinglists/create',
        name: 'createtrackinglisttemplate',
        component: CreateTrackingListTemplate,
        meta: {
            breadCrumb: 'Trackinglist erstellen',
            parents: [{route: '/templates/trackinglists', name: 'Vorlagen'}]
        }
    },
    {
        path: '/templates/trackinglists/:id/update',
        name: 'edittrackinglisttemplate',
        component: EditTrackingListTemplate,
        meta: {
            breadCrumb: 'Trackinglist aktualisieren',
            parents: [{route: '/templates/trackinglists', name: 'Vorlagen'}]
        }
    },
    {
        path: '*',
        component: Error404
    }
];

export default routes;